import router from '@/router.js'
// import { enableBodyScroll, disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default class Loader {
  constructor() {
    // bindings
    this.resetLoader = this.resetLoader.bind(this)
    this.activateLoader = this.activateLoader.bind(this)
    this.suspendLoader = this.suspendLoader.bind(this)
    this.timer = null;

    // privates
    this._loader_wrapper = document.getElementById('loader-wrapper')
    this._wrapper = document.getElementById('wrapper')
  }

  resetLoader() {
    if (this._loader_wrapper) {
      document.body.classList.add('lock')
      // disableBodyScroll(this._wrapper)
      this._loader_wrapper.offsetHeight
      this._loader_wrapper.classList.remove('no-trans')
      this._wrapper.removeAttribute('style')
    }
  }

  activateLoader() {
    if (this._loader_wrapper) {
      clearTimeout(this.timer)
      document.body.classList.add('lock')
      // disableBodyScroll(this._wrapper)
      this._loader_wrapper.classList.remove('show')
      this._loader_wrapper.classList.add('show')

      this.timer = setTimeout(() => {
        location.reload(true);
      }, 4000);
    }
  }

  suspendLoader() {
    if (this._loader_wrapper) {
      this._loader_wrapper.offsetHeight
      this._loader_wrapper.classList.remove('show')
      document.body.classList.remove('lock')
      // clearAllBodyScrollLocks()
      clearTimeout(this.timer)
    }
  }
}
